import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-lockdown-mode-popup",
  templateUrl: "./lockdown-mode-popup.component.html",
  styleUrls: ["./lockdown-mode-popup.component.css"],
})
export class LockdownModePopupComponent implements OnInit {
  form: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<LockdownModePopupComponent>,
  ) {
    console.log(data);
    this.form = data;
  }

  ngOnInit() {}
}
